import axios from "axios";
import authHeader from "./auth-header";
import getmainurl from "./tools.service";

const getTrackersState = async () => {
    return await axios({
        url: getmainurl() + '/api/v1/trackers/state', method: 'get', headers: authHeader()
    }).catch(function (error) {
        console.log(error.response.data);
    })
}

const setTrackerState = async (data) => {
    return await axios({
        url: getmainurl() + '/api/v1/trackers/state', method: 'post', headers: authHeader(), data: data
    }).catch(function (error) {
        console.log(error.response.data);
    })
}

const setAllTrackersState = async (data) => {
    return await axios({
        url: getmainurl() + '/api/v1/trackers/all_state', method: 'post', headers: authHeader(), data: data
    }).catch(function (error) {
        console.log(error.response.data);
    })
}

/* -------------------------------------------------------------------------------- *\
|                               downloadImuCsv
\* -------------------------------------------------------------------------------- */
const downloadImuCsv = async (data) =>
{
    const urlask = getmainurl() + '/api/v1/trackers/downloadimucsv';
    const response = await fetch(urlask, { method: 'POST', headers: { ...authHeader(), 'Content-Type': 'application/json' }, body: JSON.stringify(data) }, data);
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = (data.trackers === 'all' || !data.trackers || data.trackers.includes(',')) ? 'imu_csv.zip' : (data.trackers + "_csv.zip");
    if (data.context) a.download = data.context + "_csv.zip";
    a.click();
    window.URL.revokeObjectURL(url);
}
/* -------------------------------------------------------------------------------- *\
|                               downloadImuBin
\* -------------------------------------------------------------------------------- */
const downloadImuBin = async (data) =>
{
    const urlask = getmainurl() + '/api/v1/trackers/downloadimubin';
    const response = await fetch(urlask, { method: 'POST', headers: { ...authHeader(), 'Content-Type': 'application/json' }, body: JSON.stringify(data) }, data);
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = (data.trackers === 'all' || !data.trackers || data.trackers.includes(',')) ? 'imu_bin.zip' : (data.trackers + "_bin.zip");
    if (data.context) a.download = data.context + "_bin.zip";
    a.click();
    window.URL.revokeObjectURL(url);
}
/* -------------------------------------------------------------------------------- *\
|                               getRaceInfos
\* -------------------------------------------------------------------------------- */
const getRaceInfos = async (racecontext, selectedRace) =>
{
    const data = { raceuuid: selectedRace };
    const urlask = getmainurl() + '/api/v1/races/infos';
    const response = await fetch(urlask, { method: 'POST', headers: { ...authHeader(), 'Content-Type': 'application/json' }, body: JSON.stringify(data) }, data);
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = racecontext + ".json";
    a.click();
    window.URL.revokeObjectURL(url);
}

/* -------------------------------------------------------------------------------- *\
|                               pingTracker
\* -------------------------------------------------------------------------------- */
const pingTracker = async (trackerId) =>
{
    try
    {
        return await axios({ url: getmainurl() + `/api/v1/trackers/ping/${trackerId}`, method: 'get', headers: authHeader() });
    }
    catch (error)
    {
        return { data: { success: false, message: error.response?.data?.message || error.message || "Erreur lors du ping du tracker" } };
    }
}

const TrackerService = {
    getTrackersState,
    setTrackerState,
    setAllTrackersState,
    downloadImuCsv,
    downloadImuBin,
    getRaceInfos,
    pingTracker
};

export default TrackerService;